import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Reusable Loader Component
 * Unified loading indicator for all operations
 * 
 * @param {string} text - Loading text to display
 * @param {string} size - Size of loader (sm, md, lg)
 * @param {string} className - Additional CSS classes
 */
const Loader = ({ text = 'Loading...', size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  return (
    <div className={`flex items-center justify-center gap-3 ${className}`}>
      <Loader2 className={`${sizeClasses?.[size]} text-blue-600 animate-spin`} />
      <span className={`${textSizeClasses?.[size]} text-gray-600`}>{text}</span>
    </div>
  );
};

export default Loader;